import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SMTeamLogo from './SMTeamLogo';
import _ from 'lodash';
import RCore from 'RCore';
import eventify from 'Eventify';
const i18Common = require('../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const incidentIdsMap = {
    goal: [7, 8, 28],
    goal_own: [10],
    assist: [34],
    yellow_card: [14],
    red_card: [15, 16],
    substitution: [32],
};

const NameScoreView = styled.div`
    font-size: 25px;
    line-height: 1;
    white-space: nowrap;
    color: ${props => props.theme.color};
    ${props => props.styles};
`;

const NoLogoView = styled.div`
    position: relative;
    color: ${props => props.theme.content.backgroundColor};
    padding-top: 36px;

    &:after {
        content: '';
        width: 150%;
        height: 600%;
        position: absolute;
        top: 0;
        left: -25%;
        z-index: -1;
        background-color: currentColor;
        color: inherit;
    }

    .sm-match-wrap {
        font-size: 25px;
        line-height: 1;
        color: ${props => props.theme.color};
        ${props => props.styles};
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .sm-match-score__team-name {
        font-weight: bold;
        text-transform: none;
        font-size: 28px;
        width: 260px;
    }

    .status {
        text-align: center;
        font-weight: bold;
        font-size: 23px;
        margin-bottom: 10px;
        color: ${props => props.theme.color};
    }
`;

const NameLogoScoreView = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 35px;
    .score-dash {
        margin: 0 10px;
    }
    > div {
        display: flex;
        align-items: center;
    }
`;

const LogoScoreView = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    color: ${props => props.theme.color};
    .wdp-team-logo {
        vertical-align: middle;
        height: 90px;
        width: auto;
    }

    &.score-small {
        .score {
            width: 80px;
        }
    }
    .score {
        display: flex;
        width: 220px;
        align-items: center;
        flex-direction: column;
        .status {
            font-size: 22px;
            text-transform: uppercase;
        }
    }

    .score-box {
        width: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
        font-size: 64px;
        line-height: 64px;
        font-weight: 700;
        .score-digit {
            display: inline-block;
            flex-grow: 1;

            width: calc(50% - 20px);
            &.home {
                text-align: right;
            }
            &.away {
                text-align: left;
            }
        }
        .score-dash {
            width: 40px;
            text-align: center;
        }
    }
    .team-name {
        display: inline-block;
        margin: 0 10px;
        font-size: 60px;
        font-weight: 700;
        width: calc(50% - 110px);

        &.home {
            text-align: right;
            .wdp-team-logo {
                margin-left: 20px;
                margin-right: 0px;
            }
        }
        &.away {
            text-align: left;
            .wdp-team-logo {
                margin-right: 20px;
                margin-left: 0px;
            }
        }
    }

    > span {
        display: inline-block;
        vertical-align: middle;
    }
`;

const LargeLogoScoreView = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: ${props => props.theme.color};

    .wdp-team-logo {
        vertical-align: middle;
        height: 140px;
        width: auto;
    }

    &.score-small {
        .score {
            width: 80px;
        }

        .team-name {
            width: calc(50% - 40px);
        }
    }
    .score {
        display: flex;
        width: 280px;
        margin-top: -50px;
        align-items: center;
        flex-direction: column;

        .status {
            font-size: 24px;
            margin-bottom: 12px;
        }
    }

    .score-box {
        width: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
        font-size: 72px;
        line-height: 1em;
        font-weight: 700;

        .score-digit {
            display: inline-block;
            flex-grow: 1;

            width: calc(50% - 20px);

            &.home {
                text-align: right;
            }

            &.away {
                text-align: left;
            }
        }

        .score-dash {
            width: 60px;
            text-align: center;
        }
    }
    .team-name {
        display: inline-block;
        margin: 0 10px;
        width: calc(50% - 110px);
        font-size: 60px;
        font-weight: 700;
        &.home {
            text-align: right;
            .wdp-team-logo {
                margin-left: 30px;
                margin-right: 0px;
            }
        }
        &.away {
            text-align: left;
            .wdp-team-logo {
                margin-right: 30px;
                margin-left: 0px;
            }
        }
    }

    > span {
        display: inline-block;
        vertical-align: middle;
    }
`;

const ExtraLargeLogoScoreView = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    color: ${props => props.theme.color};

    .wdp-team-logo {
        vertical-align: middle;
        height: 250px;
        width: auto;
    }

    &.score-small {
        .score {
            width: 80px;
        }

        .team-name {
            width: calc(50% - 40px);
        }
    }
    .score {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 230px;

        .status {
            font-size: 24px;
            margin-bottom: 12px;
        }
    }

    .score-box {
        width: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
        font-size: 120px;
        line-height: 1em;
        font-weight: 700;

        .score-digit {
            display: inline-block;
            flex-grow: 1;

            width: calc(50% - 20px);

            &.home {
                text-align: right;
            }

            &.away {
                text-align: left;
            }
        }

        .score-dash {
            width: 60px;
            text-align: center;
        }
    }
    .team-logo {
        display: inline-block;
        margin: 0 10px;
    }

    > span {
        display: inline-block;
        vertical-align: middle;
    }
    
    .penalty-title {
      font-size: 30px;
      line-height: 1em;
    }
`;

const sortIncidents = (incidents, assistIncidentIds, goalIncidentIds) => {
    //Simple sort by minute and incident id
    const sortedByMinAndId = _.sortBy(incidents, ['min', 'incidentId']);

    //Find assist incidents which stay before associated goal incident and create map
    const assistsToGoalsMap = {};
    for (const inc of sortedByMinAndId) {
        const { typeId } = inc;
        if (assistIncidentIds.indexOf(typeId) > -1) {
            const assistIndex = _.findIndex(sortedByMinAndId, i => i.incidentId === inc.incidentId);
            const goalIndex = _.findIndex(
                sortedByMinAndId,
                i => i.min === inc.min && goalIncidentIds.indexOf(i.typeId) > -1 && i.teamId === inc.teamId,
            );

            if (isNaN(assistIndex) || isNaN(goalIndex)) return;

            if (assistIndex < goalIndex) {
                assistsToGoalsMap[assistIndex] = goalIndex;
            }
        }
    }

    //Swap positions of assist and goal in the array so assist always goes after goal
    for (const assistIndex in assistsToGoalsMap) {
        if (!assistsToGoalsMap.hasOwnProperty(assistIndex)) continue;
        const goalIndex = assistsToGoalsMap[assistIndex];
        const assist = sortedByMinAndId[assistIndex];

        sortedByMinAndId[assistIndex] = sortedByMinAndId[goalIndex];
        sortedByMinAndId[goalIndex] = assist;
    }

    return sortedByMinAndId;
};

const NameScore = styled.span`
    color: ${props => props.theme.color};
    ${props => props.isOwnGoal && `color: ${props.theme.negativeColor};`} ${props =>
    props.isOwnGoal && `font-weight: 700;`} ${props => props.scored && `font-weight: 700;`};
    .sm-match-score__score {
        display: inline-block;
        margin: 0 10px;
    }

    &.no-logo {
        display: flex;
        align-items: center;
        /*hyphens: auto;*/

        .sm-match-score__score {
            font-size: 74px;
            font-weight: bold;
            color: ${props => props.theme.primaryColor};
            margin: 0 30px;
        }
    }
`;

const Divider = styled.span`
    width: 30px;
    text-align: center;
    font-size: 74px;
    font-weight: bold;
    color: ${props => props.theme.primaryColor};
`;

const getScore = props => {
    const { event, incidentId } = props;

    if (!incidentId) return event.score;

    const assistIncidentIds = incidentIdsMap['assist'];
    const goalIncidentIds = incidentIdsMap['goal'];
    const ownGoalIncidentIds = incidentIdsMap['goal_own'];

    let { incidents } = event;

    //Sort incidents so when incidents minutes are equal, they will be sorted by IDS numbers
    incidents = sortIncidents(incidents, assistIncidentIds, goalIncidentIds);

    let incidentIndex = incidents.findIndex(inc => inc.incidentId === incidentId);

    return incidents.slice(0, ++incidentIndex).reduce(
        (score, inc) => {
            const { typeId } = inc;

            const homeGoal = inc.home && goalIncidentIds.indexOf(typeId) !== -1;
            const homeOwnGoal = !inc.home && ownGoalIncidentIds.indexOf(typeId) !== -1;

            const awayGoal = !inc.home && goalIncidentIds.indexOf(typeId) !== -1;
            const awayOwnGoal = inc.home && ownGoalIncidentIds.indexOf(typeId) !== -1;

            if (homeGoal || awayOwnGoal) score.home = ++score.home;
            if (awayGoal || homeOwnGoal) score.away = ++score.away;

            return score;
        },
        { home: 0, away: 0 },
    );
};

const MatchScore = (props, ctx) => {
    const { view, event, styles, homeIsOwnGoal, awayIsOwnGoal, homeScored, awayScored, alwaysShowZero, penaltyTitle } = props;
    const lang = _.get(ctx, 'info.lang', 'en');
    let content = null;

    const homeName = event.homeShortName || (event.homeName && event.homeName.substr(0, 3).toUpperCase());
    const awayName = event.awayShortName || (event.awayName && event.awayName.substr(0, 3).toUpperCase());
    const score = getScore(props);

    const e = eventify(event);

    const hasScore = e.isLive() || e.isPostponed() || e.isFT();

    if (view === 'noLogo' || view === MatchScore.SMALL) {
        content = (
            <NoLogoView className="noLogo">
                {hasScore && <div className="status __c__c1noLogo">{i18(`status.full.${e.statusType}`, lang)}</div>}
                <div className="sm-match-wrap">
                    <NameScore
                        className="no-logo"
                        style={{ textAlign: 'right' }}
                        isOwnGoal={homeIsOwnGoal}
                        scored={homeScored}
                    >
                        <div className="sm-match-score__team-name __c__c2noLogo">{event.homeName}</div>
                        <span className="sm-match-score__score __c__c3noLogo">{alwaysShowZero ? 0 : score.home}</span>
                    </NameScore>
                    <Divider className="__c__c4noLogo"> - </Divider>
                    <NameScore className="no-logo" isOwnGoal={awayIsOwnGoal} scored={awayScored}>
                        <span className="sm-match-score__score __c__c3noLogo">{alwaysShowZero ? 0 : score.away}</span>
                        <div className="sm-match-score__team-name __c__c2noLogo">{event.awayName}</div>
                    </NameScore>
                </div>
            </NoLogoView>
        );
    }

    if (view === 'nameScore' || view === MatchScore.SMALL) {
        content = (
            <NameScoreView styles={styles}>
                <NameScore isOwnGoal={homeIsOwnGoal} scored={homeScored}>
                    {homeName}
                    <span className="sm-match-score__score">{alwaysShowZero ? 0 : score.home}</span>
                </NameScore>
                <span> - </span>
                <NameScore isOwnGoal={awayIsOwnGoal} scored={awayScored}>
                    <span className="sm-match-score__score">{alwaysShowZero ? 0 : score.away}</span>
                    {awayName}
                </NameScore>
            </NameScoreView>
        );
    }

    if (view === 'logoScore' || view === MatchScore.CLEAN) {
        content = (
            <LogoScoreView className={`${!hasScore && 'score-small'}`}>
                <span className="team-name home">
                    <span>{event.homeShortName}</span>
                    <SMTeamLogo tournamentId={event.tournamentTemplateId} fontSize={32} teamId={event.homeId} />
                </span>

                <div className="score">
                    {hasScore && (
                        <span className="status __c__c1logoScore">{i18(`status.full.${e.statusType}`, lang)}</span>
                    )}
                    {hasScore && (
                        <div className="score-box __c__c3logoScore">
                            <span className="score-digit home">{score.home}</span>
                            <span className="score-dash">-</span>
                            <span className="score-digit away">{score.away}</span>
                        </div>
                    )}
                    {!hasScore && (
                        <div className="score-box __c__c3logoScore">
                            <span className="score-dash">-</span>
                        </div>
                    )}
                </div>

                <span className="team-name away">
                    <SMTeamLogo tournamentId={event.tournamentTemplateId} fontSize={32} teamId={event.awayId} />
                    <span>{event.awayShortName}</span>
                </span>
            </LogoScoreView>
        );
    }

    if (view === 'nameLogoScore') {
        content = (
            <NameLogoScoreView>
                <div>
                    {homeName}
                    <SMTeamLogo
                        height={50}
                        style={{ marginLeft: 15 }}
                        tournamentId={event.tournamentTemplateId}
                        teamId={event.homeId}
                    />
                </div>
                {hasScore && (
                    <div className="score-box __c__c3nameLogoScore">
                        <NameScore isOwnGoal={homeIsOwnGoal} scored={homeScored}>
                            <span className="home">{score.home}</span>
                        </NameScore>

                        <span className="score-dash">-</span>
                        <NameScore isOwnGoal={awayIsOwnGoal} scored={awayScored}>
                            <span className="away">{score.away}</span>
                        </NameScore>
                    </div>
                )}
                {!hasScore && (
                    <div className="score-box __c__c3nameLogoScore">
                        <span className="score-dash">-</span>
                    </div>
                )}
                <div>
                    <SMTeamLogo
                        height={50}
                        style={{ marginRight: 15 }}
                        tournamentId={event.tournamentTemplateId}
                        teamId={event.awayId}
                    />
                    {awayName}
                </div>
            </NameLogoScoreView>
        );
    }

    if (view === 'simpleLogoScore') {
        content = (
            <LogoScoreView className={`${!hasScore && 'score-small'} logo-score-view`}>
                <span className="team-name home">
                    <SMTeamLogo
                        tournamentId={event.tournamentTemplateId}
                        teamId={event.homeId}
                        fontSize={38}
                        teamShortName={homeName}
                    />
                </span>

                <div className="score" style={{ width: '150px' }}>
                    {hasScore && (
                        <div className="score-box __c__c3simpleLogoScore">
                            <NameScore
                                style={{ width: 'calc(50% - 40px)', textAlign: 'right' }}
                                isOwnGoal={homeIsOwnGoal}
                                scored={homeScored}
                            >
                                <span className="home">{score.home}</span>
                            </NameScore>

                            <span className="score-dash">-</span>
                            <NameScore
                                style={{ width: 'calc(50% - 40px)', textAlign: 'left' }}
                                isOwnGoal={awayIsOwnGoal}
                                scored={awayScored}
                            >
                                <span className="away">{score.away}</span>
                            </NameScore>
                        </div>
                    )}
                    {!hasScore && (
                        <div className="score-box __c__c3simpleLogoScore">
                            <span className="score-dash">-</span>
                        </div>
                    )}
                </div>

                <span className="team-name away">
                    <SMTeamLogo
                        tournamentId={event.tournamentTemplateId}
                        teamId={event.awayId}
                        fontSize={38}
                        teamShortName={awayName}
                    />
                </span>
            </LogoScoreView>
        );
    }

    if (view === 'largeLogoScore' || view === MatchScore.CLEAN) {
        content = (
            <LargeLogoScoreView className={`${!hasScore && 'score-small'}`}>
                <span className="team-name home">
                    <SMTeamLogo
                        tournamentId={event.tournamentTemplateId}
                        height={140}
                        teamId={event.homeId}
                        teamShortName={homeName}
                    />
                </span>

                <div className="score">
                    {hasScore && (
                        <span className="status __c__c1largeLogoScore">{i18(`status.full.${e.statusType}`, lang)}</span>
                    )}
                    {hasScore && (
                        <div className="score-box __c__c3largeLogoScore">
                            <span className="score-digit home">{score.home}</span>
                            <span className="score-dash">-</span>
                            <span className="score-digit away">{score.away}</span>
                        </div>
                    )}
                    {!hasScore && (
                        <div className="score-box __c__c3largeLogoScore">
                            <span className="score-dash">-</span>
                        </div>
                    )}
                </div>

                <span className="team-name away">
                    <SMTeamLogo height={140} teamId={event.awayId} teamShortName={awayName} />
                </span>
            </LargeLogoScoreView>
        );
    }

    if (view === 'extraLargeLogoScore' || view === MatchScore.CLEAN) {
        content = (
            <ExtraLargeLogoScoreView className={`${!hasScore && 'score-small'}`}>
                <span className="team-logo">
                    <SMTeamLogo
                        tournamentId={event.tournamentTemplateId}
                        height={250}
                        teamId={event.homeId}
                        teamShortName={homeName}
                    />
                </span>

                <div className="score">
                    {hasScore && (
                        <div className="score-box __c__c3__extraLargeLogoScore">{score.home}-{score.away}</div>
                    )}
                    {!hasScore && <div className="score-box __c__c3__extraLargeLogoScore">-</div>}
                    {penaltyTitle && <div className="penalty-title">{penaltyTitle}</div>}
                </div>

                <span className="team-logo">
                    <SMTeamLogo height={140} teamId={event.awayId} teamShortName={awayName} />
                </span>
            </ExtraLargeLogoScoreView>
        );
    }

    return <div className="sm-match-score">{content}</div>;
};

MatchScore.propTypes = {
    view: PropTypes.string.isRequired, //nameScore, logoScore, logoNameScore
    event: PropTypes.object.isRequired,
    incidentId: PropTypes.number,
};
MatchScore.contextTypes = {
    moment: PropTypes.func,
    info: PropTypes.object,
};

MatchScore.CLEAN = 'CLEAN';
MatchScore.SMALL = 'SMALL';
export default MatchScore;
export { getScore };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/MatchScore.js
 **/